import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import FilterSearch from '@atlassian/jira-common-components-filter-search/src/main.tsx';
import { useIntl } from '@atlassian/jira-intl';
import type { PrioritySchemeFilters } from '../../services/priority-schemes-page/types';
import messages from './messages';
import { PriorityFilterPicker } from './priority-filter-picker';

export type FilterProps = {
	filters: PrioritySchemeFilters;
	setSelectedPriorityIds: (priorityIds: PrioritySchemeFilters['priorityIds']) => void;
	setSchemeName: (schemeName: string) => void;
};

export const Filter = ({ filters, setSelectedPriorityIds, setSchemeName }: FilterProps) => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={filterWrapperStyles}>
			<Box xcss={inputWrapperStyles}>
				<FilterSearch
					value={filters.schemeName}
					onChange={setSchemeName}
					shouldFitContainerWidth
					placeholder={formatMessage(messages.searchFieldPlaceholder)}
				/>
			</Box>
			<PriorityFilterPicker
				selectedPriorityIds={filters.priorityIds}
				setSelectedPriorityIds={setSelectedPriorityIds}
			/>
		</Box>
	);
};

const filterWrapperStyles = xcss({
	marginTop: 'space.250',
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
});

const inputWrapperStyles = xcss({
	width: '220px',
	marginRight: 'space.100',
});
